import { Button, useTranslation } from '@ukpostbox/frontend-framework';
import React from 'react';

type SelectEverythingBannerType = {
	selectedCount: number;
	selectedLabel: string;
	callback: () => void;
};

function SelectEverythingBanner(props: SelectEverythingBannerType) {
	const { t } = useTranslation();

	return (
		<div className='select-everything-banner'>
			{t('counts.selectedItems', { count: props.selectedCount })}
			<Button title={props.selectedLabel} onClick={() => props.callback()} />
		</div>
	);
}

export default SelectEverythingBanner;
